import { Button } from '@/components/ui/button'
import { useSearchFilters } from './useSearchFilters'

export function SearchButtonMobile() {
  const { commitFilters } = useSearchFilters()

  return (
    <div className="flex items-center">
      <Button
        size="default"
        variant="red"
        className="w-full items-center justify-center rounded-xl py-6"
        onClick={() => commitFilters()}
      >
        Hledat
      </Button>
    </div>
  )
}

export function SearchButtonDesktop() {
  const { commitFilters } = useSearchFilters()

  return (
    <div className="ml-4 hidden items-center md:flex">
      <Button
        size="icon"
        variant="red"
        className="h-12 w-12 items-center justify-center rounded-xl"
        onClick={() => commitFilters()}
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M22.6504 21.1774L15.6942 14.2211C16.7736 12.8256 17.3576 11.1193 17.3576 9.32469C17.3576 7.17647 16.5192 5.16219 15.0031 3.64344C13.487 2.12469 11.4674 1.28897 9.32185 1.28897C7.17631 1.28897 5.15667 2.12736 3.6406 3.64344C2.12185 5.15951 1.28613 7.17647 1.28613 9.32469C1.28613 11.4702 2.12453 13.4899 3.6406 15.0059C5.15667 16.5247 7.17363 17.3604 9.32185 17.3604C11.1165 17.3604 12.8201 16.7765 14.2156 15.6997L21.1719 22.6533C21.1922 22.6737 21.2165 22.6899 21.2431 22.7009C21.2698 22.712 21.2984 22.7176 21.3272 22.7176C21.3561 22.7176 21.3846 22.712 21.4113 22.7009C21.4379 22.6899 21.4622 22.6737 21.4826 22.6533L22.6504 21.4881C22.6708 21.4677 22.687 21.4435 22.6981 21.4168C22.7091 21.3902 22.7148 21.3616 22.7148 21.3327C22.7148 21.3039 22.7091 21.2753 22.6981 21.2486C22.687 21.222 22.6708 21.1978 22.6504 21.1774ZM13.5647 13.5675C12.429 14.7006 10.9236 15.3247 9.32185 15.3247C7.72006 15.3247 6.2147 14.7006 5.07899 13.5675C3.94595 12.4318 3.32185 10.9265 3.32185 9.32469C3.32185 7.7229 3.94595 6.21486 5.07899 5.08183C6.2147 3.94879 7.72006 3.32469 9.32185 3.32469C10.9236 3.32469 12.4317 3.94611 13.5647 5.08183C14.6977 6.21754 15.3218 7.7229 15.3218 9.32469C15.3218 10.9265 14.6977 12.4345 13.5647 13.5675Z"
            fill="#F6F6F6"
          />
        </svg>
      </Button>
    </div>
  )
}
